module.exports = __webpack_public_path__ + "img/order_plate_blue.079e98eb.svg";